import styled from 'styled-components';
import { fonts, colors } from 'stylesheets';

export const Coment = styled.div`
  margin-top: 10px;
`;

export const ComentBox = styled.textarea`
  border: 1px solid ${({ hasValue }) => (hasValue ? `${colors.greyDark}` : `${colors.greyLight}`)};
  border-radius: 2px;
  resize: none;
  width: 100%;
  margin: 5px 0;
  height: 100px;
  padding: 10px;
`;

export const Label = styled.span`
  font-size: 14px;
  color: ${colors.greyDark};
`;
